<template>
  <!-- 检索机构 -->
  <div class="layer">
    <highSearch @highSearch="highSearch"></highSearch>
    <div class="retrievalInst" id="retrievalInst">
      <!-- 该关键词如果还有另外一种类型则显示并且可以跳转 -->
      <div class="meaning width" v-if="instData.typedata[0].show">
        <div class="mean width">
          {{instData.typedata[0].name}}是一个多义词，当前检索类型为
          <el-link type="primary" :underline="false">机构</el-link>，
          其他检索类型有：
          <el-link
            type="primary"
            :underline="false"
            @click="othertype"
          >{{instData.typedata[0].othertype?'人名':'研究方向'}}</el-link>
        </div>
      </div>
      <!-- 主题 -->
      <div class="center width">
        <left
          ref="left"
          :topSubjects="instData.data.topSubjects"
          :topKeywords="topKeywords"
          :topOrganizations="instData.data.topOrganizations"
          :isLeftClick="loading1"
          @screenData="getScreen"
        ></left>
        <div class="experts">
          <div class="experts-header">
            <img src="static/img/icon/user.png" />
            <span>专家</span>
          </div>
          <div class="search-r">
            <div class="menu clearfix">
              <h4
                v-if="!user"
              >{{intercept ? '已经为您检索到'+instData.data.total+'条，游客显示前100条，登录可以查看更多。':'已经为您检索到'+instData.data.total+'条。'}}</h4>
              <h4
                v-else
              >{{!intercept ?'已经为您检索到'+instData.data.total+'条。':'已经为您检索到'+instData.data.total+'条，当前状态下展示为前1000条，如需更多数据请与项目组联系。'}}</h4>
              <div class="showway">
                <span>展示格式</span>
                <img @click="index=1" src="static/img/icon/nine.png" alt />
                <img @click="index=2" class="listimg" src="static/img/icon/list.png" alt />
              </div>
            </div>
            <div v-show="index===1" class="res-list clearfix" v-loading="loading1">
              <div
                class="exp-box"
                :style="{width:expWidth}"
                v-for="(item,index) in instData.data.obj"
                :key="index"
              >
                <div class="exp-int clearfix">
                  <el-image
                    @click="goDetail(item,index)"
                    class="exp-header"
                    :src="item.avatar?item.avatar:'/old/public'+item.avatarUrl"
                    fit="fill"
                  >
                    <div slot="placeholder" class="image-slot">
                      <img
                        width="80px"
                        height="100px"
                        src="http://expert.ckcest.cn/autoload/images/avatar.png"
                      />
                    </div>
                    <div slot="error" class="image-slot">
                      <img
                        width="80px"
                        height="100px"
                        src="http://expert.ckcest.cn/autoload/images/avatar.png"
                      />
                    </div>
                  </el-image>
                  <div class="exp-textint">
                    <h5 @click="goDetail(item,index)">{{item.name}} {{item.honor}}</h5>
                    <p :title="item.organization">{{item.organization}}</p>
                    <p>{{/^[0-9]+$/.test(item.kId) ? (item.claimType == 0?'机器认领':(item.claimType == 1?'本人认领':'人工认领')) : '未认领'}}</p>
                  </div>
                </div>
                <p
                  class="isni"
                  v-if="item.isni"
                >ISNI：{{item.isni.replace(/(.{4})/g,'$1-').slice(0,item.isni.length+3) }}</p>
                <p class="isni" v-else></p>
                <p class="subject" :title="item.subject" v-if="item.subject">学科：{{item.subject}}</p>
                <p class="subject" :title="item.subject" v-else></p>
                <ul
                  class="keywords clearfix"
                  v-if="item.keyword"
                  style="background-color: #f5f5f5;"
                >
                  <li v-for="li in item.keywordList" :key="li">{{li}}</li>
                </ul>
                <ul class="keywords clearfix" v-else></ul>
              </div>
            </div>
            <div v-show="index===2" class="res-listelse">
              <ul v-loading="loading1">
                <li class="clearfix" v-for="( item, index ) in instData.data.obj" :key="index">
                  <div class="eles-info">
                    <div class="else-header">
                      <el-image
                        @click="goDetail(item,index)"
                        class="exp-header"
                        :src="item.avatar?item.avatar:'/old/public'+item.avatarUrl"
                        fit="fill"
                      >
                        <div slot="placeholder" class="image-slot">
                          <img
                            width="100%"
                            height="100%"
                            src="http://expert.ckcest.cn/autoload/images/avatar.png"
                          />
                        </div>
                        <div slot="error" class="image-slot">
                          <img
                            width="100%"
                            height="100%"
                            src="http://expert.ckcest.cn/autoload/images/avatar.png"
                          />
                        </div>
                      </el-image>
                    </div>
                    <div class="else-int">
                      <h5
                        @click="goDetail(item,index)"
                        style="color:#879b86"
                      >{{item.name}} {{item.honor}}</h5>
                      <p style="color:#879b86" :title="item.organization">{{item.organization}}</p>
                      <p>{{/^[0-9]+$/.test(item.kId) ? (item.claimType == 0?'机器认领':(item.claimType == 1?'本人认领':'人工认领')) : '未认领'}}</p>
                      <!-- <p>认领人：中国工程院院士馆</p> -->
                      <p
                        v-if="item.isni"
                      >ISNI：{{item.isni.replace(/(.{4})/g,'$1-').slice(0,item.isni.length+3)}}</p>
                      <p style="min-height:20px" v-else></p>
                      <p :title="item.subject" v-if="item.subject">学科：{{item.subject}}</p>
                      <p :title="item.subject" v-else></p>
                      <div class="else-keywords" v-if="item.keyword">
                        <span>研究方向：</span>
                        <a v-for="li in item.keywordList" :key="li">{{li}}</a>
                      </div>
                      <div class="else-keywords" v-else></div>
                    </div>
                    <ul class="elseinttext">
                      <li
                        v-if="item.introduction"
                        class="elseinttext-item"
                      >{{item.introduction.trim() }}</li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <pagination
            :pageSizes="pageSizes"
            :total="user?(instData.data.total>1200?1200:instData.data.total):(instData.data.total>120?120:instData.data.total)"
            :page.sync="pageData.PageIndex"
            :limit.sync="pageData.PageSize"
            :layout="layout"
            @pagination="getPage()"
          />
        </div>
      </div>
      <!-- 机构信息 -->
      <div class="info width">
        <el-row v-loading="loading3">
          <el-col :span="instDetail.shortNameAlt?11:15" class="info-mr">
            <div class="info-header">
              <span>{{instDetail.name}}</span>
              <span style="margin-left:30px">{{instDetail.nameAlt}}</span>
            </div>
            <div class="results">
              <img src="static/img/icon/user.png" />
              <span>{{instDetail.topCreators}}</span>
              <img style="margin-left:30px" class="img" src="static/img/icon/page.png" />
              <span>{{instDetail.topResources}}</span>
            </div>
            <div class="info-details" style>
              <span style="text">{{instDetail.introduction}}</span>
            </div>
          </el-col>
          <el-col
            :span="instDetail.shortNameAlt?12:8"
            v-if="Object.keys(pieChartData).length"
            class="info-chart"
            :offset="1"
          >
            <pie-chart
              style="-webkit-filter: saturate(0.5);filter: saturate(0.5);margin-right:20px;"
              class="pie"
              id="ALLPieChart"
              height="300px"
              :width="instDetail.shortNameAlt?'50%':'100%'"
              :chart-data="pieChartData"
            />
            <pie-chart
              v-if="instDetail.shortNameAlt"
              style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
              class="pie"
              id="ALLPieChart"
              height="300px"
              width="50%"
              :chart-data="ePieChartData"
            />
          </el-col>
          <el-col :span="instDetail.shortNameAlt?12:8" v-else :offset="1">
            <div v-loading="true" style="min-height:300px"></div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import highSearch from "@/components/common//highSearch";
import left from "@/components/commonrRetrieve/left";
import Chart from "@/components/Charts/LineMarker";
import LineChart from "@/components/Charts/LineChart";
import PieChart from "@/components/Charts/PieChart";
import { getBase64Avatar } from "@/api/center";
import { getOrg, getRes } from "@/api/retrieveInst";
import { search } from "@/api/common";
import { checkReplacePath } from "@/utils/index";
export default {
  name: "RetrieveInst",
  props: {},
  watch: {
    index: {
      deep: true,
      handler(val) {
        if (val === 2) {
          this.pageData.PageSize = 3;
          this.pageData.PageIndex = this.pageIndex2;
          this.pageSizes = [3];
        } else {
          this.pageData.PageSize = 12;
          this.pageData.PageIndex = this.pageIndex1;
          this.pageSizes = [12];
        }
        this.getPage();
      }
    },
    screenWidth: function(val) {
      this.changeExpWidth(val);
    }
  },
  components: {
    Pagination,
    highSearch,
    left,
    Chart,
    LineChart,
    PieChart
  },
  computed: {},
  data() {
    return {
      instData:
        this.$route.params.data === undefined
          ? JSON.parse(localStorage.getItem("instData"))
          : this.$route.params.data, // 传入参数
      user: localStorage.getItem("user"),
      /* 分页 */
      layout: "prev, pager, next, jumper",
      pageData: {
        No: "",
        Name: "",
        PageSize: 12,
        PageIndex: 0
      }, // 分页信息
      fieldDataParams: JSON.parse(localStorage.getItem("fieldDataParams")),
      intercept: false, // 检索到条数文字
      pageIndex1: 0, // 密集布局当前页
      pageIndex2: 0, // 单行布局当前页
      index: 1, // 当前页
      instDetail: [], // 机构基本信息
      pieChartData: [], // 学科分布
      ePieChartData: [], // 英文学科分布
      loading2: false, // 加载动画2
      pageSizes: [12], // 每页数量
      loading1: false, // 加载动画1
      loading3: true, // 加载动画3
      screenData: {}, // 左侧栏返回值
      k: "",
      topKeywords: [], // 研究主题
      expWidth: "23%", // 专家信息宽度
      screenWidth: document.documentElement.clientWidth // 屏幕宽度
    };
  },

  mounted() {
    var _this = this;
    this.changeExpWidth(this.screenWidth);
    window.onresize = function() {
      // 定义窗口大小变更通知事件
      _this.screenWidth = document.documentElement.clientWidth; // 窗口宽度
    };
    let str = "";
    this.fieldDataParams = this.instData.typedata.map(item => {
      str += item.name + " ";
    });
    this.fieldDataParams.k =
      str.length > 1 ? str.substring(0, str.length - 1) : "";

    localStorage.setItem("instData", JSON.stringify(this.instData));
    this.instData.data.obj = this.instData.data.obj;
    // this.keys();
    this.init();
  },
  methods: {
    goDetail(data, index) {
      let query = {};
      if (/^\d+$/.test(data.kId)) {
        query.kId = data.kId;
      } else {
        query.name = data.name;
        query.institute = data.institute || data.organization;
      }
      query.k = this.fieldDataParams.queryk
        ? this.fieldDataParams.queryk.join(" ")
        : this.fieldDataParams.k;
      if (query.keyword == query.k) {
        delete query.k;
      } else {
        query.keyword = query.k;
        delete query.k;
      }
      localStorage.setItem("val", query.keyword);
      let routeData = this.$router.resolve({ name: "Detail", query: query });
      window.open(routeData.href, "_blank");
      // this.$router.push({ name: 'Detail', query: query })
    },
    init(par) {
      this.topKeywords = [];
      this.instData.data.obj.forEach(async (item, index) => {
        var avatar = "";
        await this.setAvatar(item, index).then(res => {
          item.avatar = res;
        });
        // this.instData.data.obj.splice(index,1,item)
        if (!item.keyword) {
          return;
        }
        // this.instData.data.obj[index].keywordList = item.keyword.split(';')
      });
      // this.instData.data.obj.map((item,i) =>{
      //   item.avatarUrl = ''
      //   this.instData.data.obj.splice(i,1,item)
      // })
      console.log(this.instData.data.obj);
      let k = "";
      if (par) {
        k = par.k;
      } else {
        if (
          this.instData.params.institute &&
          this.instData.params.institute.length
        ) {
          this.instData.params.institute.forEach((item, index) => {
            k = k + item + " ";
          });
        }
        if (
          this.instData.params.keywords &&
          this.instData.params.keywords.length
        ) {
          this.instData.params.keywords.forEach((item, index) => {
            k = k + item + " ";
          });
        }
      }
      this.k = k;
      let data = {
        name: this.instData.typedata[0].name,
        type: ""
      };
      this.loading3 = true;
      // 获取机构基本信息
      getOrg(data)
        .then(res => {
          this.loading3 = false;
          this.instDetail = res.data.data.result[0];
          this.instDetail.topCreators = res.data.stat.topCreators;
          this.instDetail.topResources = 0;
          res.data.stat.topResources.forEach(element => {
            this.instDetail.topResources =
              this.instDetail.topResources + element.doc_count;
          });
          this.getRes();
        })
        .catch(err => {
          console.log(err);
        });

      this.key(0); // 研究主题
    },
    async highSearch(params) {
      console.log(params);
      await this.getPage(params, true);
      this.init(params);
    },
    setAvatar(item) {
      return new Promise(resolve => {
        if (!isNaN(item.kId)) {
          getBase64Avatar({ kId: item.kId }).then(res => {
            resolve(
              res.data[0].data[0] && res.data[0].data[0].avatar
                ? res.data[0].data[0].avatar.replace(/[\r\n]/g, "")
                : ""
            );
          });
        }
      });
    },
    // 根据页面宽度设置专家排数
    changeExpWidth(val) {
      if (val > 1480) {
        this.expWidth = "23%";
      } else if (val > 1200) {
        this.expWidth = "32%";
      }
    },
    /* 获取研究主题
     * 研究主题又专家列表中的keyword组成
     * 判断第一个人的keyword个数是否大于10
     * 如果大于则研究主题等于这个人的keyword的前10
     * 反之加上下一个人的keyword
     */
    key(index) {
      this.topKeywords = [];
      if (this.instData.data.obj[index].keyword) {
        this.topKeywords = this.topKeywords.concat(
          this.instData.data.obj[index].keywordList ||
            this.instData.data.obj[index].keyword.split(";")
        );
      } else {
        this.topKeywords = this.topKeywords.concat({});
      }

      if (this.topKeywords.length > 10) {
        this.keys();
      } else {
        this.key(index + 1);
      }
    },
    // 研究主题赋值
    keys() {
      let temp = this.instData.data.topKeywords || this.topKeywords;
      let data = [];
      temp.forEach((item, index) => {
        if (index > 9) {
          return;
        }
        data.push({
          key: item.key || item
        });
      });

      this.topKeywords = data;
    },
    // 获取左侧栏返回值
    getScreen(data) {
      debugger;
      this.screenData = data;
      this.pageData.PageIndex = 0;
      let par = {};
      if (sessionStorage.getItem("highSearch")) {
        par = JSON.parse(sessionStorage.getItem("highSearch"));
      }
      this.getPage(par);
    },

    // 学科分布
    getRes() {
      this.loading2 = true;
      const data = {
        name: [
          this.instDetail.name,
          this.instDetail.nameAlt ? this.instDetail.nameAlt : "",
          this.instDetail.shortNameAlt ? this.instDetail.shortNameAlt : ""
        ],
        code: ["J"],
        year: [2010, 2018]
      };
      getRes(data)
        .then(res => {
          this.loading2 = false;
          this.pieChartData = res.data.tops.topSubjects.slice(0, 10);
        })
        .catch(err => {
          console.log(err);
        });
      if (this.instDetail.shortNameAlt) {
        this.loading2 = true;
        let temp = {
          name: [
            this.instDetail.name,
            this.instDetail.nameAlt ? this.instDetail.nameAlt : "",
            this.instDetail.shortNameAlt ? this.instDetail.shortNameAlt : ""
          ],
          code: ["I"],
          year: [2010, 2018]
        };
        getRes(temp).then(res => {
          this.loading2 = false;
          this.ePieChartData = res.data.tops.topSubjects.slice(0, 10);
        });
      }
    },
    // 检索专家
    async getPage(par = this.fieldDataParams, rest = false) {
      this.setTip();
      this.loading1 = true;
      let index =
        this.pageData.PageIndex - 1 > 0 ? this.pageData.PageIndex - 1 : 0;
      if (rest) {
        this.pageData.PageIndex = 1;
        index = 0;
      }
      let data = {
        k: this.k,
        ...par,
        from: index * this.pageData.PageSize,
        size: this.pageData.PageSize,
        ...this.screenData
      };
      if (data.next) {
        data.para = this.instData.data.query;
      }
      if (!par.k) {
        delete data.k;
      }
      if (this.index === 1) {
        this.pageIndex1 = this.pageData.PageIndex;
      } else {
        this.pageIndex2 = this.pageData.PageIndex;
      }
      if (this.screenData && this.$store.state.highSearch) {
        data = Object.assign(data, this.screenData);
      }
      if (!this.$store.state.highSearch) {
        delete data.s;
      }
      this.fieldDataParams = data;
      localStorage.setItem("fieldDataParams", JSON.stringify(data));
      await search(data)
        .then(res => {
          this.loading1 = false;
          this.$message.closeAll();
          if (!res.data.total) {
            let Pheight = document.body.clientHeight;
            let offset = Pheight * 0.45;
            this.$message.info({
              showClose: true,
              message: "该条件下无检索专家，已为你返回上次检索条件",
              offset: offset,
              duration: "5000"
            });
            this.$refs.left.setScreen(
              JSON.parse(localStorage.getItem("screen"))
            );
          } else {
            if (!checkReplacePath(this, res, 2, data, "instData")) {
              localStorage.setItem("screen", JSON.stringify(this.screenData));
              this.$refs.left.setScreen(999);
              if (!res.typedata.length) {
                res.typedata = [{}];
              }
              this.instData = res;
              this.keys(); //研究方向赋值
              this.total = this.instData.data.total;
              this.instData.data.obj.forEach(async (item, index) => {
                this.instData.data.obj[index].keywordList = item.keyword.split(
                  ";"
                );
                var avatar = "";
                await this.setAvatar(item, index).then(req => {
                  item.avatar = req;
                });

                if (
                  item.avatarUrl === null ||
                  item.avatarUrl === " " ||
                  item.avatarUrl === undefined
                ) {
                  this.instData.data.obj[index].avatarUrl = "";
                }
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 设置检索条数文字
    setTip() {
      this.intercept = false;
      if (this.index === 1) {
        if (this.user) {
          console.log(this.pageData.PageIndex);

          if (this.pageData.PageIndex === 100) {
            this.intercept = true;
          }
        } else {
          if (this.pageData.PageIndex === 10) {
            this.intercept = true;
          }
        }
      } else if (this.index === 2) {
        if (this.user) {
          if (this.pageData.PageIndex === 400) {
            this.intercept = true;
          }
        } else {
          if (this.pageData.PageIndex === 40) {
            this.intercept = true;
          }
        }
      }
    },
    // 其他检索类型
    othertype() {
      let data = this.k;
      this.$router.push({
        name: "Loading",
        params: { data: data, searchtype: this.instData.typedata[0].othertype }
      });
    }
  }
};
</script>

<style lang="scss">
.retrievalInst {
  .meaning {
    height: 40px;
    width: 92vw;
    background: #fff;
    .mean {
      padding-left: 40px;
      height: 40px;
      display: flex;
      align-items: center;
    }
  }
  .info {
    margin-top: 20px;
    background: #fff;
    width: 92vw;
    height: 370px;
    border-top: 2px solid #000;
    padding-bottom: 20px;
    ::-webkit-scrollbar {
      width: 6px;
      background-color: #f2f2f2;
    }
    ::-webkit-scrollbar-thumb {
      background-color: #dedede;
    }
    .info-mr {
      height: 100%;
      padding-left: 30px;
      margin-top: 20px;
    }
    .info-header {
      font-weight: 700;
      font-size: 1em;
    }
    .results {
      display: flex;
      align-items: center;
      height: 30px;
      margin-top: 10px;
      img {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }
    }
    .info-details {
      overflow: auto;
      height: 200px;
      text-indent: 2em;
      margin-top: 20px;
      text-indent: 2em;
    }
    .info-chart {
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
  .center {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    .experts {
      background: #fff;
      width: 69%;
      .experts-header {
        margin-top: 20px;
        margin-left: 40px;
        img {
          width: 20px;
          height: 20px;
        }
      }
      .search-r {
        width: 100%;
        .menu {
          padding: 1em;
          margin-bottom: 15px;
          h4 {
            float: left;
            font-size: 14px;
          }
          .showway {
            float: right;
            span {
              font-size: 12px;
              font-weight: 600;
              vertical-align: text-top;
            }
            img {
              display: inline-block;
              width: 20px;
              height: 20px;
              cursor: pointer;
              margin-left: 5px;
            }
          }
        }
        .res-list {
          margin-left: 3%;
          .exp-box {
            float: left;
            margin-right: 1%;
            margin-bottom: 15px;
            border: 1px #ccc solid;
            padding: 10px;
            .exp-int {
              display: flex;
              flex-direction: row;
              .exp-header {
                width: 80px;
                float: left;
                height: 100px;
                cursor: pointer;
              }
              .exp-textint {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-left: 10px;
                font-size: 12px;
                h5 {
                  cursor: pointer;
                  margin-bottom: 10px;
                }
                p {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  margin-bottom: 5px;
                }
              }
            }
            .isni {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              min-height: 20px;
              font-size: 12px;
              margin-top: 10px;
            }
            .subject {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 12px;
              min-height: 20px;
            }
            .keywords {
              height: 44px;
              overflow: hidden;
              margin-top: 5px;
              li {
                height: 20px;
                flex-shrink: 1;
                float: left;
                border: 1px #ccc solid;
                padding: 1px 2px;
                border-radius: 4px;
                font-size: 12px;
                margin: 0 4px 2px 0;
              }
            }
          }
        }
        .res-listelse {
          ul {
            li {
              ::-webkit-scrollbar {
                width: 6px;
                background-color: #f2f2f2;
              }
              ::-webkit-scrollbar-thumb {
                background-color: #dedede;
              }
              height: 240px;
              border: 1px #ccc solid;
              padding: 20px;
              margin-bottom: 10px;
              .eles-info {
                display: flex;
                flex-direction: row;
                .else-header {
                  float: left;
                  .exp-header {
                    cursor: pointer;
                    display: block;
                    width: 120px;
                    height: 160px;
                    margin-right: 15px;
                  }
                }
                .else-int {
                  float: left;
                  margin-right: 15px;
                  h5 {
                    cursor: pointer;
                    font-size: 14px;
                  }
                  p {
                    width: 300px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 12px;
                    margin-top: 10px;
                  }
                  .else-keywords {
                    width: 300px;
                    height: 48px;
                    overflow: hidden;
                    margin-top: 10px;
                    span,
                    a {
                      font-size: 12px;
                    }
                    a {
                      height: 20px;
                      margin: 0 5px 4px 0;
                      display: inline-block;
                      border: 1px #ccc solid;
                      padding: 2px 4px;
                      border-radius: 4px;
                    }
                  }
                }
              }
              .else-chart {
                margin-top: 30px;
              }
              .elseinttext {
                float: left;
                width: 60%;
                font-size: 12px;
                overflow: auto;
                height: 200px;
                text-indent: 2em;
                .elseinttext-item {
                  border: none;
                  margin-bottom: 0;
                  height: 200px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/RetrieveInst.vue